import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * SearchBar Component
 * 
 * Standardized search input with pill styling and consistent appearance.
 * Part of the Base44 Design System.
 * 
 * @param {string} value - Current search value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {string} className - Additional classes
 */
export const SearchBar = ({ 
  value, 
  onChange, 
  placeholder = "Search...", 
  className,
  ...props 
}) => {
  return (
    <div className={cn("relative flex items-center", className)}>
      <Search className="absolute left-4 h-4 w-4 text-slate-400 dark:text-slate-500 pointer-events-none" />
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="h-9 w-full bg-slate-100 dark:bg-slate-800 border-0 rounded-full pl-10 pr-4 text-sm dark:text-slate-100 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-0 placeholder:text-slate-400 dark:placeholder:text-slate-500"
        {...props}
      />
    </div>
  );
};
